import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { message } from 'antd';
import { Button } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { API_URL } from '../../../../../../constants';
import AddSalesOpportunityModal from './components/AddSalesOpportunityModal';
import SalesOpportunityCard from './components/SalesOpportunityCard';
import './styles.scss';
import useSearchParams from '../../../../../../hooks/useSearchParams';

const SalesOpportunities = props => {
  const [loading, setLoading] = useState(false);
  const [salesOpportunities, setSalesOpportunities] = useState([]);
  const [showOpportunityModal, setShowOpportunityModal] = useState(false);
  const { setValue } = useSearchParams();

  const fetchSalesOpportunities = useCallback(async () => {
    if (props.client.client_id) {
      setLoading(true);

      try {
        const response = await axios.get(`${API_URL}/xa/clients/${props.client.client_id}/sales-opportunities`, {
          params: {
            page: 1,
            pageSize: 4,
          },
        });

        setSalesOpportunities(response.data.results);
      } catch (error) {
        message.error('Error Fetching Sales Opportunities');
      } finally {
        setLoading(false);
      }
    }
  }, [props.client.client_id]);

  const showAddSalesOppHandler = () => {
    setShowOpportunityModal(!showOpportunityModal);
  };


  useEffect(() => {
    fetchSalesOpportunities();
  }, [props.client.client_id]);

  const salesName = useMemo(() => props?.auth?.merchantConfig.SALES_OPP_NAME || 'Sales Opportunities', [props.auth.merchantConfig]);

  return (
    <>
      <div className="qv-section">
        <div className="qv-section-header">
          <div className="qv-section-header-left">
            <h3 className="qv-section-title">{salesName}</h3>
            <button
              type="button"
              className="qv-section-add-btn"
              onClick={() => setShowOpportunityModal(true)}
            >
              <FontAwesomeIcon size="1x" icon={['far', 'plus']} />
            </button>
          </div>

          <Button
            type="link"
            onClick={() => {
              props.setViewAllType('allSalesOpportunities');
            }}
            className="cb-link-btn"
          >
            View All
          </Button>
        </div>

        <div className="qv-section-body">
          {loading && <div className="qv-section-empty">Loading...</div>}

          {!loading && !salesOpportunities.length && (
            <div className="qv-section-empty">{`No ${salesName}`}</div>
          )}

          {/* @TODO: SALES OPPORTUNITY MODAL */}

          {!loading &&
            Boolean(salesOpportunities.length) &&
            salesOpportunities.map(item => (
              <SalesOpportunityCard
                key={item.id}
                salesOpportunity={item}
                onClick={() => {
                  setValue('oppId', item.id);
                  setValue('oppLocation', 'quickViewSalesOpp');
                }}
              />
            ))}
        </div>
      </div>

      {showOpportunityModal && (
        <AddSalesOpportunityModal
          showAddSalesOppHandler={showAddSalesOppHandler}
          salesPipelines={props.client.salesPipelines}
          associateId={props.auth.userId}
          merchantId={props.auth.merchantId}
          client={props.client}
          setSalesOpportunities={setSalesOpportunities}
          getReminderData={props.getReminderData}
          getClientData={props.getClientData}
          refetchReminders={props.refetchReminders}
          refetchAutoMessages={props.refetchAutoMessages}
        />
      )}
    </>
  );
};

export default SalesOpportunities;
